import { render, staticRenderFns } from "./coding.vue?vue&type=template&id=971d150c&scoped=true&"
import script from "./coding.vue?vue&type=script&lang=js&"
export * from "./coding.vue?vue&type=script&lang=js&"
import style0 from "./coding.vue?vue&type=style&index=0&id=971d150c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971d150c",
  null
  
)

export default component.exports